export default __webpack_public_path__ + "static/media/p6.d70fa3e2.jpeg";